import { DateTime } from 'luxon';

/**
 * Pickup times this far ahead of the appointment are almost always a data-entry
 * mistake and turn into No Loads once the trip is offered out. Advisory only -
 * the trip can still be submitted.
 */
export const PICKUP_TIME_APPOINTMENT_WARNING_MINUTES = 4 * 60;

/**
 * Only a pickup ahead of the appointment is in scope; a pickup after the
 * appointment is covered by the blocking pickup-offset validation.
 */
export function isPickupTimeFarFromAppointment(
  pickupDateTime: unknown,
  appointmentDateTime: unknown,
): boolean {
  if (!(pickupDateTime instanceof DateTime) || !pickupDateTime.isValid) {
    return false;
  }
  if (
    !(appointmentDateTime instanceof DateTime) ||
    !appointmentDateTime.isValid
  ) {
    return false;
  }

  const minutesBeforeAppointment = appointmentDateTime.diff(
    pickupDateTime,
    'minutes',
  ).minutes;

  return minutesBeforeAppointment >= PICKUP_TIME_APPOINTMENT_WARNING_MINUTES;
}
